













import Vue, { PropType } from 'vue';
import VueApexCharts from 'vue-apexcharts';
import { ApexOptions } from 'apexcharts';
import ResizeObserver from 'resize-observer-polyfill';

export default Vue.extend({
  props: {
    series: {
      type: Array as PropType<number[]>,
      default: () => [0],
    },
    labels: {
      type: Array as PropType<string[]>,
      default: () => [''],
    },
    data: {
      type: Object as PropType<{ [key: string]: number }>,
    },
    colors: {
      type: Array as PropType<string[]>,
      default: () => ['#24BE99'],
    },
    dataName: {
      type: String,
      default: 'Count',
    },
    type: {
      type: String,
      default: 'bar',
    },
  },
  components: {
    apexchart: VueApexCharts,
  },
  mounted() {
    this.resizeObserver = new ResizeObserver(this.onResize);
    this.resizeObserver.observe(this.$refs.barChart as HTMLDivElement);
  },
  beforeDestroy() {
    this.resizeObserver?.disconnect();
  },
  computed: {
    computedChartWidth(): string {
      return this.chartWidth + 'px';
    },
    computedChartHeight(): string {
      return this.chartHeight + 'px';
    },
    computedSeries(): [{ name: string; data: number[] }] {
      if (this.data) {
        return [{ name: this.dataName, data: Object.values(this.data) }];
      } else return [{ name: this.dataName, data: this.series }];
    },
    chartOptions(): ApexOptions {
      return {
        labels: this.data ? Object.keys(this.data) : this.labels,
        colors: this.colors,
        dataLabels: {
          enabled: this.type !== 'area',
        },
        plotOptions: {
          pie: {
            expandOnClick: true,
            donut: {
              size: '0%',
            },
          },
        },
        legend: {},
      };
    },
  },
  data(): {
    chartWidth: number;
    chartHeight: number;
    resizeObserver: ResizeObserver | null;
  } {
    return {
      chartWidth: 100,
      chartHeight: 100,
      resizeObserver: null,
    };
  },
  methods: {
    onResize() {
      const divElement = this.$refs.barChart as HTMLDivElement;
      if (divElement) {
        this.chartWidth = Math.min(
          divElement.clientHeight * 1.6,
          divElement.clientWidth,
        );
        this.chartHeight = Math.min(divElement.clientHeight, this.chartWidth);
      }
    },
  },
});
